<template>
  <RemissionsCreate />
</template>

<script>
import RemissionsCreate from '@/views/admin/remissions/Create.vue';

export default {
  name: 'OperadorSalesCreate',
  components: { RemissionsCreate },
};
</script>
